import { api, LIMIT } from './BaseApi'
import {
  ICategoriesRequestDto,
  ICategoriesResponseDto,
  ICategory,
} from './dto/CategoriesObjDto'
import { createQueryStringSmart } from 'utils/createQueryString'

export const categoryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCategory: builder.query<ICategoriesResponseDto, ICategoriesRequestDto>({
      query: (params) => ({
        url: `/category/${createQueryStringSmart(params)}`,
      }),
      providesTags: ['Category'],
    }),
    getCategorySimpleList: builder.query<
      ICategoriesResponseDto,
      ICategoriesRequestDto
    >({
      query: (params) => ({
        url: `/category/get_category_simple_info/${createQueryStringSmart(
          params,
        )}`,
      }),
      providesTags: ['Category'],
    }),
    getCategoryByRestaurant: builder.query<ICategoriesResponseDto, string>({
      query: (id) => ({
        url: '/category/',
        params: {
          restaurant: id,
          limit: LIMIT.base,
          ordering: 'name',
        },
      }),
      providesTags: ['Category'],
    }),
    getCategoryById: builder.query<ICategory, number>({
      query: (id) => ({
        url: `/category/${id}/`,
      }),
      providesTags: ['Category'],
    }),
    addCategory: builder.mutation<ICategory, Partial<ICategory>>({
      query: (body) => ({
        url: '/category/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Category'],
    }),
    updateCategory: builder.mutation<ICategory, Partial<ICategory>>({
      query: (body) => ({
        url: `/category/${body.id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Category'],
    }),
    archiveMultipleCategory: builder.mutation<
      ICategory,
      { categories: number[] }
    >({
      query: ({ categories }) => ({
        url: `/category/archive_multiple_categories/`,
        method: 'PATCH',
        body: { categories },
      }),
      invalidatesTags: ['Category'],
    }),
  }),
})

export const {
  useGetCategoryQuery,
  useGetCategorySimpleListQuery,
  useGetCategoryByRestaurantQuery,
  useAddCategoryMutation,
  useGetCategoryByIdQuery,
  useUpdateCategoryMutation,
  useArchiveMultipleCategoryMutation,
} = categoryApi
